import { Component, signal, ViewChild } from '@angular/core';
import { Stepper } from 'primeng/stepper';
import { DocumentiSearchDocRow, DocumentiSearchFilters, DocumentiSearchRequest } from 'src/app/shared/models/documento-search.model';
import { HeaderDistruzioneOperazioniMassive } from '../models/operazioni-massive.model';

@Component({
  selector: 'app-distruzione-massiva',
  template:`
      <div class="card card-w-title">
      <p-stepper #stepper [(activeStep)]="activeStep" [linear]="true" orientation="horizontal">
          <p-stepperPanel header="Intestazione">
              <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                <app-stepper-step-header stepTitle="1" stepDescription="Intestazione" [index]="index" [active]="activeStep" (onClick)="onClick.emit()"></app-stepper-step-header>
              </ng-template>        
              <ng-template pTemplate="content" let-nextCallback="nextCallback">
                  <div class="grid">
                    <div class="col-12">
                      <app-intestazione-distruzione (onCompiled)="saveHeader($event)"></app-intestazione-distruzione>
                    </div>
                    <div class="col-12 buttons flex justify-content-end">
                      <button pButton type="button" icon="fas fa-arrow-right" label="Avanti" title="Avanti" (click)="doneSelectedHeader()" class="mr-2"
                        [disabled]="!header"></button>
                    </div>  
                  </div>
              </ng-template>
          </p-stepperPanel>
          <p-stepperPanel  header="Selezione Documenti">
              <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                <app-stepper-step-header stepTitle="2" stepDescription="Selezione Documenti" [index]="index" [active]="activeStep" (onClick)="onClick.emit()"></app-stepper-step-header>
              </ng-template>        
              <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback">
                <app-ricerca-documenti [baseRequest]="baseRequest" (selected)="selectedDocuments($event)"></app-ricerca-documenti>
                <div class="buttons flex justify-content-end w-full">
                  <button pButton type="button" icon="fas fa-arrow-right" label="Avanti" title="Avanti" (click)="doneSelectedDocument()" class="mr-2 mt-2"
                    [disabled]="!documentToDestroySelected.length"></button>
                </div>             
              </ng-template>
          </p-stepperPanel>
          <p-stepperPanel  header="Procedi">
            <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
              <app-stepper-step-header stepTitle="3" stepDescription="Procedi" [index]="index" [active]="activeStep" (onClick)="onClick.emit()"></app-stepper-step-header>
            </ng-template>          
            <ng-template pTemplate="content" let-prevCallback="prevCallback">            
              <app-riepilogo-distruzione *ngIf="header &&  searchDone()" [header]="header" [items]="documentToDestroySelected"></app-riepilogo-distruzione>
            </ng-template>
          </p-stepperPanel>
      </p-stepper>
    </div>
  `
})
export class DistruzioneMassivaComponent {

  @ViewChild('stepper', {static: true}) stepper!: Stepper;
  
  public activeStep: number = 0;

  public header : HeaderDistruzioneOperazioniMassive | undefined;
  public documentToDestroySelected : DocumentiSearchDocRow[] = [];
  public searchDone  = signal<boolean>(false);

  public readonly baseRequest = {
          pageFirstRow: 0,
          includeAllegati: false,
          pageSize: 10,
          sortField: 'Protocollo',
          sortOrder: -1,
          filters: {
            onlyCanBeDestroyed:true,
            onlyCanBeDestroyedWithoutRegistry: false,
            excludeDestroyed:true,
          } as DocumentiSearchFilters
        } as DocumentiSearchRequest;

  public selectedDocuments( items :  DocumentiSearchDocRow[]): void {
    this.documentToDestroySelected = [ ...items]
  }

  public doneSelectedHeader(): void {
    if ( this.header) {
      this.baseRequest.filters.onlyCanBeDestroyed = this.header.salvaSuRegistro;
      this.baseRequest.filters.onlyCanBeDestroyedWithoutRegistry = !this.header.salvaSuRegistro;
      
      this.activeStep += 1;
    }
  }

  public doneSelectedDocument(): void {
    if ( this.documentToDestroySelected.length > 0) {
      this.activeStep += 1;
      this.searchDone.set(true);
    }
  }

  public saveHeader(value: HeaderDistruzioneOperazioniMassive | undefined) {
    this.header = undefined;
    if ( value) {
      this.header = { ... value};
    }
  }
  
  public resetHeader() {
    this.header = undefined;
  }
}
